import {Mapper} from '@s-ui/domain'

export default class SearchResultsFavoritesToAdsListValueObjectMapper extends Mapper {
  constructor({adEntityFactory, adsListValueObjectFactory}) {
    super({
      adEntityFactory,
      adsListValueObjectFactory
    })
    this._adEntity = adEntityFactory
    this._adsListValueObject = adsListValueObjectFactory
  }

  /**
   * @param {String} data
   */
  map = ({searchResultsValueObject, userFavoritesValueObject}) => {
    const {items: userFavorites} = userFavoritesValueObject.toJSON()
    const {items: results, ...rest} = searchResultsValueObject.toJSON()
    const searchResultsFavorites = results.map(result => {
      const isFavorite = userFavorites.find(userFavorite => Number(userFavorite.id) === Number(result.id))
      return this._adEntity({...result, isFavorite: Boolean(isFavorite)})
    })
    return this._adsListValueObject({items: searchResultsFavorites, ...rest})
  }
}
